"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ExternalToInternalEnumMappings_1 = require("../../EnumMappings/ExternalToInternalEnumMappings");
const ErrorHelpers_1 = require("../../Utils/ErrorHelpers");
const Param_1 = require("../../Utils/Param");
const ServiceImplBase_1 = require("./ServiceImplBase");
class ZoneServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "zone-service" /* Zone */;
    }
    setVisibilityAsync(dashboard, dashboardZoneMap, zoneVisibilityMap) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'setVisibilityAsync',
            [api_internal_contract_js_1.ParameterId.Dashboard]: dashboard,
            [api_internal_contract_js_1.ParameterId.ZoneIdsVisibilityMap]: {},
        };
        // zoneVisibilityMap can be either an object or a Map - convert it to a Map
        const parameterAsMap = Param_1.Param.convertParameterToMap(zoneVisibilityMap, 'zoneVisibilityMap');
        parameterAsMap.forEach((value, key) => {
            ErrorHelpers_1.ErrorHelpers.verifyZoneIsValid(dashboardZoneMap, Number.parseInt(key, 10));
            ErrorHelpers_1.ErrorHelpers.verifyEnumValue(value, api_external_contract_js_1.DashboardObjectVisibilityType, 'DashboardObjectVisibilityType');
            parameters[api_internal_contract_js_1.ParameterId.ZoneIdsVisibilityMap][key] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.setVisibilityType.convert(value);
        });
        return this.execute(api_internal_contract_js_1.VerbId.SetZoneVisibility, parameters).then((response) => {
            return;
        });
    }
    moveAndResizeAsync(dashboard, dashboardZoneMap, dashboardObjectPositionAndSizeUpdateArray) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.Dashboard]: dashboard,
            [api_internal_contract_js_1.ParameterId.DashboardObjectPositionAndSizeUpdateList]: dashboardObjectPositionAndSizeUpdateArray,
        };
        dashboardObjectPositionAndSizeUpdateArray.forEach((dashboardObject) => {
            ErrorHelpers_1.ErrorHelpers.verifyZoneIsValidAndFloating(dashboardZoneMap, dashboardObject.dashboardObjectID);
            ErrorHelpers_1.ErrorHelpers.verifyWidthAndHeightOfDashboardObjectPositionAndSizeUpdate(dashboardObject);
        });
        return this.execute(api_internal_contract_js_1.VerbId.MoveAndResizeZones, parameters).then((response) => {
            return;
        });
    }
}
exports.ZoneServiceImpl = ZoneServiceImpl;
//# sourceMappingURL=ZoneServiceImpl.js.map